import axios from "axios";

import { apiEndpoint } from "../configuration";
import CookiesServices from "../services/CookiesServices";
import { applyVendorScopeToRequest, applyVendorScopeToResponse } from "../utils/accessControl";

// Must be false unless the API sends Access-Control-Allow-Credentials: true
// for your origin. Auth uses Bearer token in headers (see interceptor below).
axios.defaults.withCredentials = false;

const http = axios.create({
  baseURL: apiEndpoint,
  withCredentials: false,
});

let interceptorsConfigured = false;

const attachAccessControlHeaders = (config) => {
  let nextConfig = config;
  try {
    nextConfig = applyVendorScopeToRequest(nextConfig);
  } catch (scopeError) {
    return Promise.reject(scopeError);
  }
  return nextConfig;
};

const onResponseSuccess = (res) => {
  if (res?.data !== undefined) {
    res.data = applyVendorScopeToResponse(res.data);
  }
  return res;
};

export const setupInterceptors = (navigate) => {
  if (interceptorsConfigured) return;
  interceptorsConfigured = true;

  http.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      const isLoginEndpoint = config.url && config.url.includes('/adminusers/verify');
      if (isLoginEndpoint && config.withCredentials !== false) {
        config.withCredentials = false;
      } else if (config.withCredentials === undefined) {
        config.withCredentials = false;
      }
      
      let token = CookiesServices.get("token");
      if (process.env.NODE_ENV === 'development') {
        console.log('CookiesServices.get("token")>', token);
      }
      
      // Only add Authorization header if token exists (skip for login)
      if (token && !config.url?.includes('/adminusers/verify')) {
        config.headers.set("Authorization", `Bearer ${token}`);
      }

      if (config.url === "/api/documents/upload") {
        config.headers.set("Content-Type", "multipart/form-data");
      } else {
        config.headers.set("Content-Type", "application/json");
      }
      
      config.headers.set("Accept", "application/json");

      return attachAccessControlHeaders(config);
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  http.interceptors.response.use(onResponseSuccess, (err) => {
      if (process.env.NODE_ENV === 'development') {
        console.log("err", err);
      }

      const { code } = err;
      if (code === "ERR_NETWORK") {
        if (process.env.NODE_ENV === 'development') {
          console.log("network Error");
        }
        // Don't show alert for network errors in production/staging
        // The calling code will handle the error
      }
      
      // Check if err.response exists before accessing status
      if (err.response) {
        const { status } = err.response;
        if (status === 401) {
          // here we have access of the useHistory() from current Router
          // navigate("/sessiontimeout");
        }
      }

      return Promise.reject(err);
    });

  axios.interceptors.request.use(
    (config) => attachAccessControlHeaders(config),
    (error) => Promise.reject(error)
  );
  axios.interceptors.response.use(
    onResponseSuccess,
    (error) => Promise.reject(error)
  );
};

export default http;
